import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'application'
const initialState = {
  
}
export const saveApplication = createApiAction('application/save', client.save('/api/application'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
        .addCase(saveApplication.fulfilled, (state, action) => {
            state.instance = action.payload
        })
  },
})

export default sessionSlice.reducer
